<template>
    <div class="screen-btn" :class="isLeft ? 'left-screen-btn' : ''" :style="{ '--theme-color': themeColor }">
      <template v-if="changeBtn.length === 2">
        <div class="screen-btn-content">
          <div class="screen-btn-content-item"  @click="changeActive(item)" :class="[classify[index], item.i === activeId ? 'active-btn' : '']" v-for="(item, index) in changeBtn" :key="item.i">
              {{ item.info.text }}
          </div>
        </div>
      </template>
      <template v-else-if="changeBtn.length > 2">
        <el-popover v-model="isPop" popper-class="screen-btn-pop" visible-arrow placement="bottom" width="160" trigger="click">
          <template #reference>
            <div class="screen-btn-content-list">
              <span>{{ getCurName }}</span>
              <i class="iconfont icon-xia"></i>
            </div>
          </template>
          <div class="btn-list-content" :style="{ '--theme-color': themeColor, '--theme-opcity-color': themeColor }">
            <div class="btn-list-content-item" v-for="item in changeBtn" :key="item.i">
              <span @click="changeActive(item)">{{ item.info.text }}</span>
            </div>
          </div>
        </el-popover>
      </template>
    </div>
</template>

<script>
export default {
  // 组件名称
  name: 'screenBtn',
  // 组件参数 接收来自父组件的数据
  props: {
    changeBtn: {
      type: Array,
      default: () => ([])
    },
    themeColor: {
      type: String,
      default: '#4e86ff'
    },
    activeId: {
      type: Number,
      default: -1
    },
    isLeft: {
      type: Boolean,
      default: false
    }
  },
  // 组件状态值
  data () {
    return {
      classify: {
        0: 'left',
        1: 'right'
      },
      isPop: false
    }
  },
  // 计算属性
  computed: {
    getCurName () {
      const cur = this.changeBtn.find(c => c.i === this.activeId)
      if (cur) {
        return cur.info.text
      } else {
        return '请选择'
      }
    }
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    changeActive(item) {
      this.isPop = false
      this.$emit('change-active', item.i)
    },
  }
}
</script>

<style scoped lang="scss">
$themeColor: var(--theme-color);
.left-screen-btn {
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .screen-btn-content {
    width: 100%;
    .screen-btn-content-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
  }
}
.screen-btn-pop {
  .btn-list-content {
    display: flex;
    flex-direction: column;
    &-item {
      display: flex;
      justify-content: space-between;
      font-weight: 400;
      height: 40px;
      align-items: center;
      color: #333333;
      cursor: pointer;
      &:hover {
        color: $themeColor;
      }
      span {
        flex: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .model {
        .iconfont {
          font-size: 12px;
        }
        .iconshanchu2 {
          margin-left: 5px;
        }
      }
    }
  }
}
.screen-btn {
    align-items: center;
    height: 100%;
    display: flex;
    &-content {
        display: flex;
        flex-wrap: nowrap;
        &-list {
          width: 160px;
          height: 30px;
          border: solid 1px $themeColor;
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px 0 18px;
          box-sizing: border-box;
          font-weight: 400;
          font-size: 14px;
          color: $themeColor;
          cursor: pointer;
          .iconfont {
            font-size: 10px;
          }
        }
        &-item {
            padding: 6px 16px;
            border: solid 1px $themeColor;
            box-sizing: border-box;
            white-space: nowrap;
            color: $themeColor;
            font-weight: 400;
            font-size: 14px;
            cursor: pointer;
            position: relative;
        }
        .active-btn {
            color: #fff;
            background-color: $themeColor;
        }
        .left {
            border-radius: 4px 0 0 4px;
            border-right: none;
        }
        .right {
            border-radius: 0 4px 4px 0;
        }
    }
}
</style>
